import { postWithFullResponse } from '@citrite/http';
import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import $ from 'jquery';
import { ChangePasswordWidget } from 'Login/DSAuth/changePasswordWidget';

const defaultOptions = {
	overlaySelector: '',
	onComplete() {},
	onError(_failureId?: string) {},
	onAuthenticationCancel() {},
	isDialog: false,
	beforeDisplayForm() {},
	displayForm() {},
};

export class ChangePasswordController {
	private options: typeof defaultOptions;
	private $container: JQuery;
	private $overlay: JQuery;
	private displayWidget: ChangePasswordWidget;
	private workspaceConfiguration: WorkspaceConfiguration;

	public constructor(
		$containerElement: JQuery,
		options: Partial<typeof defaultOptions>,
		workspaceConfiguration: WorkspaceConfiguration,
		private showForms: () => void
	) {
		this.options = $.extend({}, defaultOptions, options);
		this.$container = $containerElement;
		this.$overlay = $(this.options.overlaySelector);
		this.workspaceConfiguration = workspaceConfiguration;

		if (this.options.isDialog) {
			// will need for password change in settings
			// this.displayWidget = new CTXS.Widgets.ElectivePasswordChangeWidget(this.$container, this.options.overlaySelector);
			this.options.beforeDisplayForm = () => {
				// this.displayWidget.cleanDialog();
			};
			this.options.displayForm = () => {
				// this.displayWidget.centerAndDisplayDialog();
			};
		} else {
			this.displayWidget = new ChangePasswordWidget(this.$container);
		}

		this.bindToUIEvents();
	}

	public showPasswordExpiryMessage(daysUntilExpiration: number) {
		const self = this;
		const options = {
			onChange() {
				self.requestPasswordChangeUI();
			},
			onContinue: self.options.onComplete,
		};
		if (!this.options.isDialog) {
			this.displayWidget.showPasswordExpiryMessage(daysUntilExpiration, options);
		}
	}

	private escapeToCancel(e: JQueryKeyEventObject) {
		if (e.keyCode === 27 /*cancel*/) {
			this.options.onAuthenticationCancel();
		}
	}

	public requestPasswordChangeUI() {
		const self = this;
		this.$container.ctxsFormsAuthentication({
			informationIconUrl: 'receiver/images/common/info.svg',
			authenticationError() {
				self.options.onError();
			},
			authenticationCancel() {
				self.onAuthCancel(self.options.isDialog);
			},
			authenticationSuccess() {
				self.onAuthSuccess(self.options.isDialog);
			},
			beforeDisplayForm: self.options.beforeDisplayForm,
			displayForm: self.options.displayForm,
			workspaceConfiguration: this.workspaceConfiguration,
			formProvider(
				url: string,
				formData: string,
				headers: object,
				callback: (data: string, authProtocolHeader: string) => void
			) {
				postWithFullResponse<string>(url, formData, { headers })
					.then(result => {
						callback(result.data, result.headers['x-citrix-explicitauthprotocol']);
					})
					.catch(() => {
						self.options.onError();
					});
			},
			showFormContainer: this.showForms,
		});

		this.$container.ctxsFormsAuthentication(
			'startAuthentication',
			this.workspaceConfiguration.authManager.changeCredentialsURL
		);
	}

	private onAuthCancel(isDialog: boolean) {
		if (isDialog) {
			// this.displayWidget.hideAndClearDialog();
			this.options.onAuthenticationCancel();
		} else {
			// Cancel change password during expiry process is the same as continuing.
			this.options.onComplete();
		}
	}

	private onAuthSuccess(isDialog: boolean) {
		if (isDialog) {
			// this.displayWidget.hideAndClearDialog();
		}
		this.options.onComplete();
	}

	private bindToUIEvents() {
		const self = this;
		this.$container.on('keydown', function (e) {
			self.escapeToCancel(e);
		});
		if (this.options.isDialog) {
			this.$overlay.on('click', function (e) {
				e.preventDefault();
				// self.displayWidget._placeFocus();
			});
		}
	}
}
